import { Landmark, Users, Handshake, Dumbbell } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const IMG =
  "https://customer-assets.emergentagent.com/job_menaam-toekomst/artifacts/ld78964t_menaam-4-10-18-pdf-grafie-3589_801702446.jpg";

const wensen = [
  { icon: Dumbbell, title: "Behoud van de Roelengahal", text: "De Roelengahal blijft onmisbaar voor sport, toernooien en kantinefunctie. Een vergrote gymzaal bij de nieuwe school is geen volwaardig alternatief — dat werd door meerdere verenigingen expliciet benoemd." },
  { icon: Landmark, title: "De school als bindend hart", text: "Een nieuwe school die niet alleen leert, maar ook verbindt. 90% van de inwoners staat achter een gedeeld gebouw voor school, sport, verenigingen en gemeenschap." },
  { icon: Handshake, title: "Ontmoeting zonder concurrentie", text: "Een laagdrempelige plek waar het dorp elkaar tegenkomt — met oog voor de bestaande horeca in Menaam. Sociale verbinding is wat een gebouw écht laat werken." },
  { icon: Users, title: "Ruimte die past bij verenigingen", text: "Goede oefen-, repetitie- en wedstrijdruimtes met aandacht voor akoestiek, plafondhoogte en vloeren. Plus centrale, droge opslag voor materialen, decor en instrumenten." },
];

export default function Ideeen() {
  return (
    <section id="ideeen" data-testid="ideeen-section" className="py-24 sm:py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* Image */}
          <Reveal className="lg:col-span-5 lg:sticky lg:top-24 order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5]">
              <img src={IMG} alt="Het beeld 'It feintsje fan Menaam' in het dorp" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A2E22]/50 to-transparent" />
            </div>
          </Reveal>

          {/* Text + cards */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <Reveal>
              <Eyebrow testid="ideeen-eyebrow">Waar Menaam op inzet</Eyebrow>
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1A2E22] mb-4">
                Vier lijnen die telkens<br />terugkomen
              </h2>
              <p className="text-[#1A2E22]/70 max-w-xl mb-9 leading-relaxed">
                Uit de enquête onder 208 inwoners/huishoudens en de gesprekken met de
                verenigingen komen vier lijnen naar voren. Deze inbreng wordt door de
                werkgroep meegenomen richting de gemeente.
              </p>
            </Reveal>

            <div className="space-y-4">
              {wensen.map((w, i) => {
                const Icon = w.icon;
                return (
                  <Reveal key={w.title} delay={i * 0.08}>
                    <div
                      data-testid={`ideeen-card-${i}`}
                      className="flex gap-4 rounded-2xl border border-[#2D6A4F]/15 bg-white p-5 transition-transform hover:-translate-y-1"
                    >
                      <div className="shrink-0 w-11 h-11 rounded-lg bg-[#2D6A4F]/10 text-[#2D6A4F] flex items-center justify-center">
                        <Icon size={20} />
                      </div>
                      <div>
                        <h3 className="font-heading text-lg font-bold text-[#1A2E22] mb-1">{w.title}</h3>
                        <p className="text-sm leading-relaxed text-[#1A2E22]/65 m-0">{w.text}</p>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
